import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  Fragment,
} from "react";
import "./styles.css";
import { useHistory, useParams, useLocation } from "react-router";

import { ReactComponent as Close } from "common/assets/svg/closeIconWhite.svg";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "common/rootReducer";
import {
  getDecimalPlacedPrice,
  getDecimalPlacedPriceString,
  getTwoDecimalValue,
} from "common/utils/menu-helper-utils";
import { CartTotal } from "common/features/cart/cartModels";
import DummyImageRestaurant from "common/assets/images/dishPlaceholder.png";
import { updateOrderTipDetail } from "common/features/order/orderActions";

import {
  saveOrderDetails,
  removeCartTip,
} from "common/features/cart/cartActions";
import { useMemo } from "react";
import { toast } from "react-toastify";
import { useOnlinePlaceOrder } from "hooks/useOnlinePlaceOrder";
export interface TipProps {
  isVisible: boolean;
  setIsVisible: any;
  totalPrice: number;
}

const AddTip = (props: TipProps) => {
  const dispatch = useDispatch();
  let paramsData = useParams<any>();

  let { merchantType, restaurantSlug, menuType, tableId, orderId } =
    useParams<any>();
  const isMobile = window.innerWidth <= 500;

  // const [
  //   makeOrder,
  //   totalItemsubTotal,
  //   totalOrderPrice,
  //   totalTaxAndCharges,
  //   totalItemTaxAmount,
  //   tipAmount1,
  //   packagingCharge,
  //   discountAmount,
  //   serviceCharge,
  //   updateOrder,
  //   walletAmount,
  //   RedeemedWalletAmt,
  // ] = usePlaceOrder();

  const [makeOrder,updateOrder,orderTotal,itemTotal,orderTotals,tipAmount1,discountAmount,deliveryFee] = useOnlinePlaceOrder();

  const restaurantCountry = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail?.country
  );

  const currentOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );

  const restaurantDetails = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail
  );

  const restaurantOrderTypeId = useSelector(
    (state: RootState) => state.restaurant.restaurantOrderTypeId
  );
  const restaurantOrderTypes = useSelector(
    (state: RootState) => state.restaurant.currentRestaurantDetail.orderTypes
  );

  const isDeliveryOrder = useMemo(() => {
    return (
      restaurantDetails.orderTypes?.some((orderType) => {
        if (menuType) {
          return orderType.typeName == menuType && orderType.typeGroup == "S";
        } else
          return (
            currentOrderTypeId == orderType.id && orderType.typeGroup == "S"
          );
      }) || false
    );
  }, [restaurantDetails, menuType, currentOrderTypeId]);

  const toastId = React.useRef<any>(null);

  const notify = (message: string) =>
    (toastId.current = toast.error(message, {
      position: toast.POSITION.TOP_CENTER,
    }));

  const isPickupOrder = useMemo(() => {
    return (
      restaurantDetails.orderTypes?.some((orderType) => {
        if (menuType) {
          return orderType.typeName == menuType && orderType.typeGroup == "P";
        } else
          return (
            currentOrderTypeId == orderType.id && orderType.typeGroup == "P"
          );
      }) || false
    );
  }, [restaurantDetails, menuType, currentOrderTypeId]);
  const [tipAmount, setTipAmount] = useState(0);
  const [tipData1, setTipData1] = useState<any>([]);
  const [tipData2, setTipData2] = useState<any>([]);
  const tipValue = useSelector((state: RootState) => state.cart.tipValue);
  //const tipValue = useSelector((state: RootState) => state.order.tip);
  const isAppliedTip = useSelector((state: RootState) => state.cart.isAppliedTip);



  useEffect(() => {
    if (tipAmount1) {
      setTipAmount(tipAmount1);
    }
  }, [tipAmount1]);

  const getImageURL = useCallback(
    (type: string) => {
      if (restaurantDetails.media.length > 0) {
        const logoMedia = restaurantDetails.media.filter(
          (media) => media.entityType == type
        )[0];
        return (
          process.env.REACT_APP_IMAGE_URL +
          logoMedia.mimeType.split("/")[0] +
          "/" +
          logoMedia.id +
          "." +
          logoMedia.mimeType.split("/")[1]
        );
      } else {
        return DummyImageRestaurant;
      }
    },
    [restaurantDetails]
  );

  useEffect(() => {
    setTipData1([
      { tip: "10", selected: false },
      { tip: "15", selected: false },
      { tip: "18", selected: false },
    ]);

    setTipData2([
      { tip: "20", selected: false },
    ]);
  }, [restaurantCountry]);

  const [percentValue, setPercentValue] = useState("");
  const [selectedPercent, setSelectedPercent] = useState<string | null>();

  const isPercentSelected = (perc: string) => {    
    return perc == selectedPercent;
  };

  const isFlatSelected = (perc: string) => {    
    return Number(perc) == Number(selectedPercent);
  };

  const percentageValue = (perc: number) => {
    return (
      getTwoDecimalValue(
        ((Number(perc) / 100) * Number(props.totalPrice))
      ) === tipAmount
    );
  };

  const calculatePercentage = (value: number) => {
    return getTwoDecimalValue(
      ((Number(value) / 100) * Number(itemTotal))
    );
  };

  useEffect(() => {
    if (tipValue === 0) {
      if(!isAppliedTip  && restaurantCountry === "US" && tipValue == 0){
        setPercentValue("15");
        setSelectedPercent("15")
      }else if(isAppliedTip  && tipValue == 0){
        setSelectedPercent("0");
      } else{
        setPercentValue("");
      }
    } else {
      setPercentValue(tipValue + "");
      setSelectedPercent(tipValue.toString())
    }
  }, [tipValue,isAppliedTip]);

  useEffect(() => {
    if (restaurantCountry == "IN") {
      if (tipAmount1 > 0) {
        setSelectedPercent(tipAmount1 + "");
      }

      if (
        tipAmount1 == 0 ||
        tipAmount1 == 10 ||
        tipAmount1 == 15 ||
        tipAmount1 == 18 ||
        tipAmount1 == 20
      ) {
      } else {
        // setPercentValue(tipAmount1 + "");
        setSelectedPercent("Enter Amount");
      }
    } else {
      if (
        tipAmount1 == calculatePercentage(0) ||
        tipAmount1 == calculatePercentage(10) ||
        tipAmount1 == calculatePercentage(15) ||
        tipAmount1 == calculatePercentage(18) ||
        tipAmount1 == calculatePercentage(20)
      ) {
      } else {
        // setPercentValue(tipAmount1 + "");
        setSelectedPercent("Enter Amount");
      }
    }
  }, [tipAmount1]);

  const isIndianRestaurant = useMemo(() => {
    return restaurantCountry == "IN";
  }, [restaurantCountry]);

  let invalidChars = ["-", "+", "e"];

  const isContactlessDineInOrder = useMemo(() => {
    if (restaurantOrderTypes) {
      return (
        (restaurantDetails.dining == 2 || restaurantDetails.dining == 3) &&
        paramsData.tableId &&
        paramsData.tableId.length > 0
      );
    }
    return false;
  }, [restaurantOrderTypeId, restaurantOrderTypes, restaurantDetails]);

  return (
    <Fragment>
      {props.isVisible && props.totalPrice > 0 ? (
        <Fragment>
          <div id="modal-background" style={{ zIndex: "20" }}></div>

          <div id="tip-container">
            <div id={isMobile ? "AddTip" : "AddTipDesktop"}>
              {isMobile && (
                <div className="close-icon-container">
                  <Close
                    onClick={() => {
                      // setTipAmount(0);
                      //setSelectedPercent(tipAmount1 + "");
                      props.setIsVisible(false);
                    }}
                  />
                </div>
              )}

              <div id="AddTip-HeadLine">
                <p>Add tip</p>
              </div>

              <div className="contactless-orderStatusHeader">
                <div className="contactless-restaurant-address-container">
                  <img
                    src={getImageURL("LOGO")}
                    alt="loading"
                    className="contactless-res-logo"
                  />
                  <div className="contactless-restaurant-address">
                    <span className="restaurant-name">
                      {restaurantDetails?.branchName}
                    </span>

                    {/* <p>{restaurantDetails.address}</p> */}
                  </div>
                </div>
              </div>
              {/* <br /> */}
              <div style={{ width: "100%" }}>
                <div className="tipAmountContainer">
                  {" "}
                  {tipData1.map((data: any) => (
                    <>
                      {isIndianRestaurant ? (
                        <span
                          key={data.tip}
                          className="TipAmount"
                          onClick={() => {
                            setSelectedPercent(data.tip);
                            setPercentValue('');
                          }}
                          style={{
                            background: isFlatSelected(data.tip)
                              ? "#3F83FF"
                              : "#ebebeb",
                            color: isFlatSelected(data.tip) ? "#fff" : "",
                            width: "25%",
                          }}
                        >
                          {/* {data.selected ? <GrCheckIcon /> : <CheckIcon />} */}
                          {/* <span
                        className={
                          isPercentSelected(data.tip) ? "selected-tip" : "tip"
                        }
                      ></span> */}
                          <Fragment>
                            <span>
                              <span className="money-symbol-tip">&#x20B9;</span>
                              {data.tip}
                            </span>
                          </Fragment>

                          <br />
                          <br />
                        </span>
                      ) : (
                        <span
                          key={data.tip}
                          className="TipAmount"
                          onClick={() => {
                            setSelectedPercent(data.tip);
                            setTipAmount(
                              getTwoDecimalValue(
                                (
                                  (Number(data.tip) / 100) *
                                  Number(props.totalPrice)
                                )
                              )
                            );
                            setPercentValue('');
                          }}
                          style={{
                            background:
                              isPercentSelected(data.tip) 
                                ? "#3F83FF"
                                : "#ebebeb",
                            color:
                              isPercentSelected(data.tip)
                                ? "#fff"
                                : "",
                            width: "30%",
                          }}
                        >
                          <Fragment>
                            <span>
                              {data.tip} % (
                              <span className="money-symbol-tip"> &#36;</span>
                              {getTwoDecimalValue(
                                (
                                  (Number(data.tip) / 100) *
                                  Number(props.totalPrice)
                                )
                              )}
                              )
                            </span>
                          </Fragment>

                          <br />
                          <br />
                        </span>
                      )}
                    </>
                  ))}
                </div>

                <div className="tipAmountContainer">
                  {" "}
                  {tipData2.map((data: any) => (
                    <>
                      {isIndianRestaurant ? (
                        <span
                          key={data.tip}
                          className="TipAmount"
                          onClick={() => {
                            setSelectedPercent(data.tip);
                            setPercentValue('');
                          }}
                          style={{
                            background: isFlatSelected(data.tip)
                              ? "#3F83FF"
                              : "#ebebeb",
                            color: isFlatSelected(data.tip) ? "#fff" : "",
                            width: "25%",
                          }}
                        >
                          <Fragment>
                            <span>
                              <span className="money-symbol-tip">&#x20B9;</span>
                              {data.tip}
                            </span>
                          </Fragment>

                          <br />
                          <br />
                        </span>
                      ) : (
                        <span
                          key={data.tip}
                          className="TipAmount"
                          onClick={() => {
                            setSelectedPercent(data.tip);
                            setTipAmount(
                              getTwoDecimalValue(
                                (
                                  (Number(data.tip) / 100) *
                                  Number(props.totalPrice)
                                )
                              )
                            );
                            setPercentValue('');
                          }}
                          style={{
                            background:
                              isPercentSelected(data.tip)
                                ? "#3F83FF"
                                : "#ebebeb",
                            color:
                              isPercentSelected(data.tip) 
                                ? "#fff"
                                : "",
                            width: "30%",
                          }}
                        >
                          <Fragment>
                            <span>
                              {data.tip} % (
                              <span className="money-symbol-tip"> &#36;</span>
                              {getTwoDecimalValue(
                                (
                                  (Number(data.tip) / 100) *
                                  Number(props.totalPrice)
                                )
                              )}
                              )
                            </span>
                          </Fragment>

                          <br />
                          <br />
                        </span>
                      )}
                    </>
                  ))}
                  <span
                    className="TipAmount"
                    onClick={() => {
                      setSelectedPercent("0");
                      setTipAmount(0);
                      setPercentValue('');
                    }}
                    style={{
                      background: selectedPercent == '0' 
                        ? "#3F83FF"
                        : "#ebebeb",
                      color: selectedPercent == '0'  ? "#fff" : "",
                      width: restaurantCountry == "IN" ? "25%" : "30%",
                    }}
                  >
                 <span>No Tip</span>
                    <br />
                    <br />
                  </span>
                  <span
                    className="TipAmount custom-tip-text"
                    onClick={() => {
                      setSelectedPercent("Enter Amount");
                      setPercentValue("");
                    }}
                    style={{
                      background: isPercentSelected("Enter Amount")
                        ? "#3F83FF"
                        : "#ebebeb",
                      color: isPercentSelected("Enter Amount") ? "#fff" : "",
                      width: restaurantCountry == "IN" ? "25%" : "30%",
                    }}
                  >
                    <span>Custom</span>
                  </span>
                </div>


                {selectedPercent == "Enter Amount" ? (
                  <div className="tipboxContainer">
                    <input
                      type="number"
                      id="custom-value"
                      placeholder="Enter tip amount"
                      max={9999}
                      value={percentValue}
                      onPaste={(e) => e.preventDefault()}
                      onKeyDown={(e) => {                        
                        if (
                          restaurantCountry == "IN" &&
                          e.target.value.length === 0 &&
                          e.key == "0"
                        ) {
                          e.preventDefault();
                        }
                        if (invalidChars.includes(e.key)|| e.key === "-"  ||  e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        if (e.target.value.length == 6) return false;
                        const value = e.target.value;

                        const isValidInput = /^\d+(\.\d{0,2})?$/.test(value);
                        if (parseFloat(value) &&isValidInput) {
                          setPercentValue(value);
                        }else if(e.target.value === ""){
                          setPercentValue("");
                        }
                        //const re = /^\d*\.?\d{0,2}$/;

                        // if (e.target.value === "" || (re.test(e.target.value) && !(/^0\d/.test(e.target.value)))) {
                        //   setPercentValue(e.target.value);
                        // }
                      }}
                    />
                  </div>
                ) : null}
                <br />
                {isDeliveryOrder ? (
                  <div className="thanksMessage">
                    “The delivery partner would appreciate the tip for getting the food ASAP to your door. 100% of tip goes to them.”
                  </div>
                ) : (
                  <div className="thanksMessage">
                    “We truly appreciate your tip. It means a lot to our staff.”
                  </div>
                )}
                <div className="bottom-button-container">
                  {!isMobile && (
                    <div
                      className="Cancel-Tip"
                      onClick={() => {
                        // setTipAmount(0);
                        setSelectedPercent(tipAmount1 + "");
                        props.setIsVisible(false);
                      }}
                    >
                      Cancel
                    </div>
                  )}
                  <div
                    className="Save-Tip"
                    style={{
                      background:
                        selectedPercent &&
                        (selectedPercent !== "Enter Amount" ||
                          (selectedPercent === "Enter Amount" &&
                            parseFloat(percentValue)))
                          ? "#67833e"
                          : "grey",
                      width: "100%",
                    }}
                    onClick={() => {
                      if (
                        selectedPercent &&
                        (selectedPercent !== "Enter Amount" ||
                          (selectedPercent === "Enter Amount" &&
                            parseFloat(percentValue)))
                      ) {
                        if (props.totalPrice > 0) {
                          if (selectedPercent == "Enter Amount") {
                            // Save Entered Amount as TIP

                            //Remove Chars other than 0-9 and .
                            let tipAmount = percentValue.replace(
                              /[^0-9.]/g,
                              ""
                            );
                            if (tipAmount.length > 0 && (restaurantCountry === "IN" ? Number(tipAmount) >= 1 : tipAmount  )) {
                              dispatch(
                                saveOrderDetails({
                                  tipValue:
                                    restaurantCountry === "US"
                                      ? parseFloat(tipAmount)
                                      : parseFloat(tipAmount),
                                  tipType: "FLATFEE",
                                })
                              );
                              props.setIsVisible(false);
                            }else{
                              notify("cannot add less than 1");
                            }
                           
                          } else if (selectedPercent == "0") {
                           // dispatch(removeCartTip());
                            isContactlessDineInOrder &&
                              dispatch(
                                updateOrderTipDetail({
                                  tipAmount: 0,
                                  orderId: orderId,
                                  transactionId: "",
                                })
                              );
                              dispatch(
                                saveOrderDetails({
                                  tipValue: 0,
                                  tipType: "FLATFEE",
                                })
                              );
                            props.setIsVisible(false);
                          } else {
                            if (selectedPercent) {
                              // Save Entered Percentage
                              if (restaurantCountry === "US") {
                                dispatch(
                                  saveOrderDetails({
                                    tipValue: +selectedPercent,
                                    tipType: "PERCENT",
                                  })
                                );
                              } else {
                                isContactlessDineInOrder &&
                                  dispatch(
                                    updateOrderTipDetail({
                                      tipAmount: +selectedPercent,
                                      orderId: orderId,
                                      transactionId: "",
                                    })
                                  );
                                dispatch(
                                  saveOrderDetails({
                                    tipValue: +selectedPercent,
                                    tipType: "FLATFEE",
                                  })
                                );
                              }
                            }
                            props.setIsVisible(false);
                          }
                          // setSelectedPercent("");
                        } else {
                          props.setIsVisible(false);
                        }
                      }
                    }}
                  >
                    Confirm tip
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Fragment>
      ) : null}
    </Fragment>
  );
};
export default AddTip;
